import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { IconButton } from "components";
import { menuPaperSx, menuItemSx, menuItemDestructiveSx } from "components/internal/menuSx";
import { MoreDots } from "./icons";

/**
 * "···" overflow menu for a game card / queue row. Reuses the same brand menu
 * styling as SplitButton and Dropdown so every popover in the app matches.
 *
 * Props:
 *   items: [{ label, onClick, destructive? }]
 *   label: aria-label for the trigger (default "Game actions")
 *   size:  IconButton size (default "sm")
 */
const ActionMenu = ({ items = [], label = "Game actions", size = "sm", className = "" }) => {
  const [anchor, setAnchor] = useState(null);

  const open = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchor(e.currentTarget);
  };
  const close = (e) => {
    if (e) e.stopPropagation();
    setAnchor(null);
  };

  return (
    <>
      <IconButton
        variant="ghost"
        size={size}
        label={label}
        aria-haspopup="menu"
        onClick={open}
        className={className}
      >
        <MoreDots />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        slotProps={{ paper: { sx: menuPaperSx } }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {items.map((item, i) => (
          <MenuItem
            key={i}
            onClick={(e) => {
              e.stopPropagation();
              if (item.onClick) item.onClick();
              setAnchor(null);
            }}
            sx={item.destructive ? menuItemDestructiveSx : menuItemSx}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
